export default {
  title: "Formation",
  caption: "Cours et leçons",
  createAi: {
    button: "Créer avec l'IA",
    title: "Créer un cours avec l'IA",
    subtitle: "Une consigne → un brouillon complet et stylé à affiner.",
    chooseSubtitle: "Choisissez comment l'IA s'en charge.",
    methodHere: "Le créer ici",
    methodHereHint:
      "Décrivez votre cours et nous générons un brouillon complet et stylé, à affiner directement ici. Le plus rapide pour une première version.",
    methodAssistant: "Utiliser votre propre assistant IA",
    methodAssistantHint:
      "Vous utilisez déjà ChatGPT, Claude ou Gemini ? Connectez-le une fois, puis demandez-lui simplement de créer vos cours — ils apparaissent ici.",
    back: "Retour",
    goal: "Objectif",
    train: "Former",
    trainHint: "Ils sauront le FAIRE ensuite",
    present: "Présenter",
    presentHint: "Faire changer d'avis",
    topic: "De quoi s'agit-il ?",
    topicPlaceholder: "ex. Onboarding des ingénieurs sur notre pipeline RAG",
    length: "Durée",
    theme: "Thème",
    generate: "Générer le brouillon",
    cancel: "Annuler",
    building: "Conception de votre cours…",
    buildingSteps: [
      "Cadrage de l'idée centrale…",
      "Conception du plan…",
      "Rédaction des leçons…",
      "Choix d'un thème…",
      "Compilation des diapositives…",
    ],
    ready: "Votre brouillon est prêt",
    generateError: "Impossible de générer le brouillon. Réessayez.",
    planLimitError:
      "Vous avez atteint la limite de {limit} cours de votre offre. Supprimez un cours ou passez à une offre supérieure pour en créer davantage.",
    close: "Fermer",
    refine: "Affiner avec l'IA",
    assistantMode: "Le construire avec l'assistant",
    assistantModeHint:
      "Créez-le étape par étape dans un chat — avec aperçus et validations.",
  },
  assistant: {
    title: "Assistant de cours",
    toggle: "Assistant IA",
    close: "Fermer l'assistant",
    editing: "Édition :",
    preview: "Aperçu",
    previewUnavailable: "Aperçu indisponible",
    deleteTitle: "Sera supprimée",
    deleteWarning: "Cette leçon et ses quiz seront définitivement supprimés.",
    reorderTitle: "Nouvel ordre",
    moved: "déplacée",
    notProvisioned:
      "L'assistant de cours n'a pas pu être configuré pour le moment. Fermez-le puis rouvrez-le.",
  },
  catalog: {
    eyebrow: "Apprendre",
    title: "Catalogue de cours",
    subtitle: "Parcourez et inscrivez-vous aux cours",
    search: "Rechercher des cours…",
    empty: "Aucun cours publié pour le moment.",
    free: "Gratuit",
    paid: "Payant",
    by: "par {author}",
    allTags: "Tous les thèmes",
    registerToEnrol: "Inscrivez-vous pour suivre",
    registerHint: "Créez un compte gratuit pour suivre ce cours.",
    language: "Langue",
    topics: "Thèmes",
    clearFilters: "Effacer les filtres",
    showMore: "+{n} de plus",
    showLess: "Voir moins",
    results: "{n} cours",
    noMatch: "Aucun cours ne correspond à vos filtres.",
  },
  myLearning: {
    eyebrow: "Votre progression",
    title: "Mes formations",
    menuTitle: "Mes formations",
    empty: "Vous n'êtes inscrit à aucun cours pour l'instant.",
    resume: "Reprendre",
    review: "Revoir",
    browse: "Parcourir les cours",
  },
  studio: {
    title: "Studio de cours",
    caption: "Créer et publier",
    usage: "{used} / {limit} cours",
    usageUnlimited: "{used} cours",
  },
  space: {
    menuTitle: "Mon espace",
    title: "Votre espace",
    subtitle:
      "Une page publique que vous pouvez partager, présentant vos catalogues de cours.",
    identity: "Identité de votre espace",
    handle: "Identifiant",
    handleHint: "Lettres, chiffres et tirets. C'est votre URL publique.",
    handleTaken: "Cet identifiant est déjà pris.",
    handleAvailable: "Disponible — votre espace sera à /lms/by/{handle}",
    resetToName: "Réinitialiser selon votre nom",
    resetToTitle: "Réinitialiser selon le titre",
    displayName: "Nom affiché",
    displayNamePlaceholder: "Jane Smith",
    headline: "Titre principal",
    headlinePlaceholder: "Maîtrisez l'ingénierie IA & les systèmes agentiques",
    headlineHint:
      "La proposition de valeur qui ouvre votre page — ce que les visiteurs vont apprendre, pas qui vous êtes.",
    subheadline: "Sous-titre",
    subheadlinePlaceholder:
      "Des cours pratiques pour ingénieurs, tech leads et managers.",
    bio: "Bio",
    bioPlaceholder: "Une ligne sur ce que vous enseignez.",
    avatar: "URL de l'avatar",
    socialLinks: "Liens & CTA",
    linkLabel: "Libellé",
    addLink: "Ajouter un lien",
    stats: "Chiffres de crédibilité",
    statsHint:
      "Optionnel — affichés avec vos propres mots à côté de vos vraies notes (ex. 15+ ans, 50+ équipes).",
    statValue: "15+",
    statLabel: "ans",
    addStat: "Ajouter un chiffre",
    publish: "Publier mon espace",
    publishHint:
      "Activé, toute personne disposant du lien peut voir votre espace.",
    save: "Enregistrer",
    saved: "Enregistré",
    urlCopied: "Lien copié",
    saveFirst: "Enregistrez votre espace pour ajouter des catalogues.",
    catalogs: "Catalogues",
    newCatalog: "Nouveau catalogue",
    noCatalogs: "Aucun catalogue pour l'instant.",
    untitledCatalog: "Catalogue sans titre",
    featured: "Cours mis en avant",
    featuredHint:
      "Choisissez les cours affichés dans la vitrine de votre espace. Laissez vide pour un classement automatique par inscriptions.",
    saveFeatured: "Enregistrer la sélection",
    status: {
      draft: "Brouillon",
      published: "Publié",
    },
    backToSpace: "Retour à votre espace",
    catalogBasics: "Détails du catalogue",
    catalogTitle: "Titre",
    catalogSlug: "Slug d'URL",
    catalogDescription: "Description",
    catalogPublish: "Publier ce catalogue",
    catalogPublishHint:
      "Un catalogue publié apparaît sur votre espace (votre espace doit aussi être publié).",
    catalogCourses: "Cours",
    noCourses: "Aucun cours dans ce catalogue pour l'instant.",
    addCoursePlaceholder: "Choisir un cours à ajouter…",
    addCourse: "Ajouter",
    noOwnedCourses: "Vous n'avez pas encore de cours à ajouter.",
    deleteCatalog: "Supprimer le catalogue",
    deleteCatalogConfirm:
      "Ceci supprime le catalogue. Vos cours ne sont pas supprimés.",
    public: {
      eyebrow: "Cours par {name}",
      notFound: "Cet espace n'est pas disponible.",
      browse: "Parcourir les cours",
      learners: "apprenants",
      courses: "cours",
      pathsTitle: "Parcours d'apprentissage",
      pathsSubtitle: "Des séquences guidées — commencez au bon endroit.",
      courseCount: "{n} cours",
      viewPath: "Voir le parcours",
      viewCatalog: "Voir le catalogue",
      popularTitle: "Cours les plus populaires",
      popularSubtitle: "Ce que les apprenants suivent en ce moment.",
      featuredTitle: "Cours mis en avant",
      featuredSubtitle: "Une sélection pour bien démarrer.",
      meet: "À propos de {name}",
      emptyCatalogs: "Aucun catalogue publié pour l'instant.",
      emptyCourses: "Aucun cours dans ce catalogue pour l'instant.",
      backToCatalog: "Retour au catalogue",
    },
  },
  editors: {
    menuTitle: "Éditeurs",
    title: "Éditeurs de cours",
    subtitle:
      "Les éditeurs peuvent créer et publier des cours sans accès administrateur complet.",
    add: "Ajouter un éditeur",
    searchPlaceholder: "Rechercher par nom ou e-mail…",
    grant: "Accorder",
    already: "Éditeur",
    noUsers: "Aucun utilisateur correspondant.",
    empty:
      "Aucun éditeur. Les administrateurs peuvent toujours créer des cours.",
    user: "Utilisateur",
    grantedAt: "Accordé le",
  },
  reviews: {
    title: "Avis",
    write: "Rédiger un avis",
    yourRating: "Votre note",
    placeholder: "Partagez votre expérience (facultatif)",
    submit: "Publier l'avis",
    update: "Mettre à jour l'avis",
    empty: "Aucun avis pour le moment — soyez le premier.",
  },
  admin: {
    title: "Gérer les cours",
    menuTitle: "Gérer les cours",
    newCourse: "Nouveau cours",
    media: "Médias",
    runs: "Exécutions de l'assistant",
    assistantSettings: "Paramètres de l'assistant",
    recompile: "Recompiler les leçons",
    recompileDone: "Leçons recompilées",
    list: {
      title: "Titre",
      owner: "Propriétaire",
      status: "Statut",
      learners: "Inscrits",
      rating: "Note",
    },
    search: "Rechercher des cours…",
    filters: {
      all: "Tous",
      mine: "Créés par vous",
      published: "Publiés",
      drafts: "Brouillons",
    },
    viewGrid: "Vue grille",
    viewList: "Vue liste",
    cardLearners: "{count} inscrits",
    privateBadge: "Privé",
    moreActions: "Plus d'actions",
    noMatches: "Aucun cours ne correspond à ces filtres.",
    openCourse: "Ouvrir le cours",
    author: "Auteur",
    tags: "Étiquettes",
    tagsHint: "Saisissez une étiquette, Entrée",
    theme: "Thème",
    themeDefault: "Par défaut",
    themeDefaultHint: "Style par défaut de la plateforme",
    themePreviewHeading: "Titre de votre cours",
    themePreviewBody:
      "Un aperçu de ce thème — fond, texte, couleur d'accent et palette des graphiques.",
    themePreviewCta: "Principal",
    price: "Prix",
    priceHint: "En centimes (0 = gratuit). La facturation n'est pas active.",
    currency: "Devise",
    defaultLanguage: "Langue par défaut",
    publishAll: "Publier le cours",
    publishAllDone: "Cours et toutes les leçons publiés",
    publishUpdate: "Publier la mise à jour",
    versionSaved: "Nouvelle version publiée",
    unpublish: "Dépublier",
    private: "Cours privé",
    privateHint:
      "Vous seul pouvez voir et gérer ce cours. Il n'apparaît dans aucun catalogue.",
    translations: "Traductions",
    addTranslation: "Ajouter une traduction",
    translationLanguage: "Code langue (ex. fr)",
    translationSaved: "Traduction enregistrée",
    lessonTranslations: "Traductions de la leçon",
    courseTitle: "Titre",
    basics: "L'essentiel du cours",
    basicsHint:
      "Titre, résumé et image — ce que les apprenants voient en premier.",
    summary: "Résumé",
    coverImage: "Image de couverture",
    coverReplace: "Remplacer",
    coverUpload: "Téléverser",
    coverRemove: "Retirer",
    coverUrlPlaceholder: "…ou collez une URL d'image",
    settings: "Paramètres",
    visibility: "Visibilité",
    pricing: "Tarification",
    advanced: "Paramètres avancés",
    advancedHint:
      "Slug, auteur et langue — définis une fois, rarement modifiés.",
    slug: "Slug",
    statusPublished: "Publié",
    statusDraft: "Brouillon",
    statusPublishedHint: "Visible par les apprenants",
    statusDraftHint: "Vous seul pouvez le voir",
    lastSaved: "Enregistré {time}",
    unsaved: "Modifications non enregistrées",
    neverSaved: "Pas encore enregistré",
    cancel: "Annuler",
    save: "Enregistrer",
    saved: "Enregistré",
    addLesson: "Leçon",
    noLessons: "Aucune leçon pour l'instant.",
    curriculumHint: "Les leçons que les apprenants suivent, dans l'ordre.",
    dragToReorder: "Glisser pour réorganiser",
    reordered: "Leçons réorganisées",
    share: {
      title: "Lien de partage",
      hint: "Un lien public en lecture seule — toute personne disposant du lien peut voir ce cours, sans compte.",
      enable: "Activer le lien de partage",
      enabled: "Lien public actif",
      copy: "Copier le lien",
      copied: "Lien copié",
      publishFirst: "Publiez le cours pour le partager.",
      stats: {
        opens: "Ouvertures",
        visitors: "Visiteurs",
        lessons: "Leçons atteintes",
        quizzes: "Tentatives de quiz",
      },
    },
    versions: {
      title: "Historique des versions",
      hint: "Chaque publication enregistre un instantané. Restaurez une version antérieure à tout moment — l'état actuel est sauvegardé au préalable, c'est donc toujours réversible.",
      empty:
        "Aucune version pour l'instant. Publier le cours enregistre le premier instantané.",
      refresh: "Actualiser",
      restore: "Restaurer",
      restoreConfirmTitle: "Restaurer la version {version} ?",
      restoreConfirmBody:
        "Le contenu du cours sera remplacé par la version {version}. L'état actuel est d'abord sauvegardé, vous pouvez donc annuler. Les apprenants inscrits et leur progression ne sont pas affectés.",
      restored: "Version {version} restaurée",
      by: "par {who}",
    },
  },
  course: {
    enroll: "S'inscrire",
    enrolled: "Inscrit",
    start: "Commencer",
    curriculum: "Programme",
    whatYouWillLearn: "Ce que vous allez apprendre",
    lessons: "leçons",
    new: "Nouveau",
    continue: "Continuer",
    percentComplete: "{percent}% terminé",
    lessonsDone: "{done} / {total} leçons",
    enrolledCount: "{count} inscrits",
  },
  quiz: {
    check: "Vérifier",
    correct: "Correct !",
    incorrect: "Pas tout à fait.",
  },
  checkpoint: {
    mark: "Marquer comme terminé",
    done: "Terminé",
  },
  flashcard: {
    label: "Carte mémo",
    show: "Afficher la réponse",
    howWell: "Vous en souveniez-vous ?",
    again: "À revoir",
    hard: "Difficile",
    good: "Correct",
    easy: "Facile",
  },
  review: {
    title: "Révision du jour",
    subtitle: "La répétition espacée empêche d'oublier ce que vous avez appris.",
    due: "{count} à réviser",
    allCaughtUp: "Tout est à jour !",
    allCaughtUpHint: "Rien à réviser pour l'instant. Revenez demain pour garder votre série.",
    remaining: "{count} restantes",
    from: "De",
    cardOf: "Carte {n} sur {total}",
    spaceHint: "Appuyez sur Espace pour révéler",
  },
  poll: {
    live: "Sondage en direct",
    vote: "vote",
    votes: "votes",
    scanToVote: "Scannez pour voter",
    submit: "Envoyer le vote",
    reset: "Réinitialiser",
    close: "Fermer",
    start: "Démarrer le sondage",
    notStarted: "Aucun sondage en cours.",
    console: "Console de sondage",
    consoleHint:
      "Ouvrir la console de sondage (QR, résultats, réinitialisation)",
    dashboard: "Historique des résultats",
    run: "session",
    runs: "sessions",
    noHistory:
      "Aucune session de sondage enregistrée. Lancez un sondage pendant une session pour constituer l'historique.",
    questions: "Questions du sondage",
    pickQuestion: "Choisissez une question pour l'ouvrir au vote.",
    noQuestions:
      "Ce cours n'a pas encore de question de sondage. Ajoutez un bloc ::: poll à une leçon.",
    linkCopied: "Lien de participation copié",
    waiting: "En attente du lancement d'une question par le présentateur…",
    recorded: "Votre vote a été enregistré",
    unavailable: "Ce sondage n'est pas disponible.",
    disabledHint:
      "Les sondages en direct sont désactivés pour ce locataire. Activez « Sondages en direct » dans les paramètres.",
    learnerHint:
      "Ceci est un sondage en direct — votre formateur le lance pendant la session et vous votez en scannant un QR code.",
    wordcloudPlaceholder: "Tapez un mot…",
    wordcloudEmpty: "En attente des premiers mots…",
  },
  qa: {
    live: "Questions en direct",
    scanToAsk: "Scannez pour poser & voter",
    markAnswered: "Marquer comme répondu",
    hide: "Masquer",
    empty:
      "Aucune question pour l'instant — elles apparaîtront ici, classées par votes.",
    learnerHint:
      "Ceci est une session de questions en direct — scannez un QR code pour poser des questions et voter pour celles des autres.",
    askPlaceholder: "Posez une question…",
    beFirst: "Soyez le premier à poser une question.",
  },
  kahoot: {
    pitch:
      "Lancez ce quiz en compétition en direct — les joueurs s'affrontent.",
    play: "Jouer en direct",
    players: "{n} joueurs",
    launch: "Lancer la question",
    reveal: "Révéler la réponse",
    showLeaderboard: "Afficher le classement",
    answered: "{n} ont répondu",
    phase: {
      lobby: "Salon",
      question: "En direct",
      reveal: "Révélation",
      leaderboard: "Classement",
      ended: "Terminé",
    },
    joinPrompt: "Choisissez un pseudo pour rejoindre le quiz.",
    nickname: "Votre pseudo",
    joinBtn: "Rejoindre la partie",
    youreIn: "C'est parti !",
    waitHost: "En attente du lancement par l'animateur…",
    locked: "Réponse verrouillée — patientez.",
    correct: "Correct !",
    incorrect: "Pas tout à fait.",
    noAnswer: "Pas de réponse cette fois.",
    score: "Score : {n}",
    thanks: "Merci d'avoir joué !",
  },
  remote: {
    pair: "Associer la télécommande",
    pairHint: "Scannez avec votre téléphone pour piloter le diaporama.",
    title: "Télécommande",
    prev: "Précédent",
    next: "Suivant",
    black: "Noir",
    white: "Blanc",
    resume: "Reprendre",
    first: "Première",
    last: "Dernière",
    scrollUp: "Défiler ↑",
    scrollDown: "Défiler ↓",
    fullscreen: "Plein écran",
    blankHint: "Écran masqué — touchez Reprendre pour réafficher la diapo.",
  },
  wysiwyg: {
    emptyTitle: "Cette leçon est vide.",
    startWriting: "Commencer à écrire",
    addBlock: "Ajouter un bloc",
    addText: "Ajouter du texte dessous",
    addSlide: "Nouvelle diapo",
    slideBreak: "Nouvelle diapo",
    drag: "Glisser pour réordonner",
    duplicate: "Dupliquer",
    delete: "Supprimer",
    editRaw: "Éditer en Markdown",
    dragHint:
      "Glissez la poignée ⠿ pour réordonner · survolez un bloc pour ajouter dessous",
  },
  remix: {
    slideAction: "Remixer",
    title: "Remixer cette diapo",
    subtitle:
      "Choisissez une retouche rapide ou décrivez un changement — vous validez avant application.",
    placeholder: "ou décrivez le changement souhaité…",
    go: "Remixer",
    again: "Réessayer",
    accept: "Accepter",
    discard: "Annuler",
    retry: "Réessayer",
    working: "Remixage…",
    hint: "Choisissez une retouche rapide ci-dessus pour voir une nouvelle version de cette diapo.",
    error: "Impossible de remixer cette diapo. Réessayez.",
    presets: {
      shorten: "Raccourcir",
      punchier: "Plus percutant",
      example: "Ajouter un exemple",
      simplify: "Simplifier",
      visual: "Plus visuel",
    },
  },
  assistantAdmin: {
    title: "Assistants IA",
    subtitle:
      "Les employés IA qui propulsent la création de cours. Ouvrez-en un pour changer son modèle.",
    name: "Nom",
    role: "Rôle",
    model: "Modèle",
    modelHint:
      "Le LLM utilisé par cet assistant. Choisissez un modèle accessible (ex. Gemini 3 Flash ou Claude Sonnet).",
    nameLocked:
      "Verrouillé — l'assistant de cours est identifié par ce nom ; le renommer le déconnecterait.",
    systemPrompt: "Prompt système",
    temperature: "Température",
    maxSteps: "Étapes max",
    permissionMode: "Approbation des outils",
    routingMode: "Mode de routage",
    injectDatetime: "Injecter la date et l'heure actuelles",
    injectDatetimeHint:
      "Ajoute la date/heure actuelle au prompt (évite les hallucinations de date).",
    empty: "Aucun assistant IA pour l'instant.",
    editTitle: "Assistant",
    back: "Retour",
    cancel: "Annuler",
    save: "Enregistrer",
    saved: "Assistant mis à jour",
  },
  classroom: {
    next: "Suivant",
    prev: "Précédent",
    nextSlide: "Suivant",
    nextLesson: "Leçon suivante",
    prevSlide: "Retour",
    prevLesson: "Leçon précédente",
    present: "Présenter",
    pageView: "Page",
    slidesView: "Diapos",
    presentHint:
      "Diaporama plein écran (flèches pour naviguer, Échap pour quitter)",
    fullscreen: "Basculer en plein écran",
    exit: "Quitter la présentation",
    complete: "Marquer la leçon comme terminée",
    completed: "Terminé",
    courseProgress: "Progression du cours",
    overview: "Aperçu",
    notes: "Notes",
    tutor: "Tuteur",
    comingSoon: "Bientôt disponible",
    toggleNotes: "Notes du présentateur (N)",
    notesPanelTitle: "Notes du présentateur · diapo {n}",
    noNotesThisSlide: "Aucune note pour cette diapo.",
    presenterView: "Vue présentateur (ouvrir la fenêtre audience)",
    nextUp: "À suivre",
    endOfDeck: "Fin du diaporama",
    audienceWaiting: "En attente du présentateur…",
    shortcuts: "Raccourcis clavier",
    shortcutsDismiss: "Appuyez sur ? ou Échap pour fermer",
    shortcutNav: "Suivant / précédent · révéler les étapes",
    shortcutBlank: "Écran noir / blanc",
    shortcutNotes: "Notes du présentateur",
    shortcutFullscreen: "Plein écran",
    shortcutHelp: "Cette aide",
    shortcutExit: "Quitter",
  },
  sharedView: {
    curriculum: "Leçons",
    selectLesson: "Choisissez une leçon pour commencer.",
    notFound: "Ce cours partagé n'est plus disponible.",
    prev: "Précédent",
    next: "Suivant",
    madeWith: "Créé avec",
    createYourOwn: "Créez le vôtre",
    downloadPdf: "Télécharger le PDF",
    print: {
      action: "Imprimer / Enregistrer en PDF",
      preparing: "Préparation de votre PDF…",
      hint: "Astuce : dans la boîte de dialogue d'impression, activez « Graphismes d'arrière-plan » pour conserver les couleurs du thème.",
    },
  },
};
